module.exports = __webpack_public_path__ + "static/media/ai-power-recommendation-banner.5a227750.png";